import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Icon Label Toggle",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-icon-label-toggle",
    args: { isActive: false, label: "" },
    argTypes: {
        isActive: { control: "boolean" },
        label: { control: "string" },
    },
};

const Template = ({ isActive, label }) =>
    html`<ux-iws-icon-label-toggle is-active="${isActive}" label="${label}">
        <p slot="tooltip-content">Hello</p>
    </ux-iws-icon-label-toggle>`;

export const Active = Template.bind({});
Active.args = { isActive: true, label: "Read Only" };

export const NotActive = Template.bind({});
NotActive.args = { isActive: false, label: "Full Access" };
